/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */
import React from 'react';
import IconComponent from '@atlaskit/icon/core/quotation-mark';
import ObjectTileBase from '../object-tile-base';
export default function BlogObjectTile(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Blog' : _ref$label,
    size = _ref.size,
    testId = _ref.testId,
    isBold = _ref.isBold;
  return /*#__PURE__*/React.createElement(ObjectTileBase, {
    label: label,
    size: size,
    testId: testId,
    isBold: isBold,
    icon: IconComponent,
    color: isBold ? "var(--ds-icon, #44546F)" : "var(--ds-icon-accent-blue, #1D7AFC)",
    backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
  });
}